// extracted by mini-css-extract-plugin
export default {"wrapper":"NotPermit_wrapper__+9U+l","container":"NotPermit_container__lcCga"};